import type { AuthSession } from "../../types/auth";

let session: AuthSession | null = null;

export const authStore = {
  getSession(): AuthSession | null {
    return session;
  },

  setSession(nextSession: AuthSession | null): void {
    session = nextSession;
  },

  getAccessToken(): string | null {
    return session?.token ?? null;
  },

  clear(): void {
    session = null;
  },
};
